<template>
    <fragment>
        <tr
                v-if="isActive || tableDataOptions.parent === 0"
                :class="{
                    'tr__sub' : deep > 0,
                    'tr__sub-two' : deep === 2,
                    'tr__sub-three' : deep === 3
                }"
        >
            <td
                v-for="(columnKey, columnKeyIndex) in Object.keys(tableDataColumns)"
                :key="`${columnKey}_${columnKeyIndex}`"
                :class="{
                    'table-multiline__td-number': typeof tableDataRows.get(rowKey)[columnKey] === 'number' || String(tableDataRows.get(rowKey)[columnKey]).indexOf('%') !== -1,
                    'table-multiline__td-name' : columnKeyIndex === 0,
                }"
            >
                <i
                    v-if="rowKeyPreloader === rowKey && columnKeyIndex === 0"
                    class="table_plus fa fa-circle-o-notch fa-spin"
                    :style="{'font-size': `12px`}"
                >
                </i>
                <i
                    v-if="tableDataOptions.rows && tableDataOptions.rows[rowKey].multiple === true && columnKeyIndex === 0 && rowKeyPreloader !== rowKey"
                    class="table_plus"
                    :class="{
                        'fa fa-plus': !tableDataRowsActive.includes(rowKey),
                        'fa fa-minus': tableDataRowsActive.includes(rowKey)
                    }"
                    @click.stop="onClickTableItem(rowKey)"
                >
                </i>
                {{
                    // typeof tableDataRows[rowKey][columnKey] === 'number' ? tableDataRows[rowKey][columnKey].toLocaleString('ru-RU') : tableDataRows[rowKey][columnKey]
                    typeof tableDataRows.get(rowKey)[columnKey] === 'number' ? tableDataRows.get(rowKey)[columnKey].toLocaleString('ru-RU') : tableDataRows.get(rowKey)[columnKey]
                }}
            </td>
        </tr>
        <table-treeview-item
            v-for="(subrowKey, subrowKeyIndex) in typeof tableSubdata.rows !== 'undefined' ? tableSubdata.rows.keys() : new Map()"
            :key="`${subrowKey}_${subrowKeyIndex}`"
            :isActive="tableDataRowsActive.includes(rowKey)"
            :tableDataOptions="tableSubdata.options"
            :tableDataColumns="tableDataColumns"
            :tableDataRows="tableSubdata.rows"
            :tableDataRowsActive="tableSubdata.rowsActive"
            :rowKey="subrowKey"
            :rowKeyPreloader="tableSubdata.rowKeyPreloader"
            :condition="{
                ...condition,
                [tableDataOptions.next]: rowKey
            }"
            :tableSubdata="tableSubdata.subdata[subrowKey] || {}"
            @onEmitClickTableItem="onEmitClickTableItem"
            :deep="(deep + 1)"
        />
    </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
export default {
    name: 'TableTreeviewItem',
    components: { 
        Fragment 
    },
    /**
     * Входные данные компонента
     * @property {object} tableDataOptions - опции
     * @property {object} tableDataColumns - колонки
     * @property {map} tableDataRows - строки
     * @property {string} rowKey - ключ текущей строки
     * @property {array} tableSubData - подстроки текущей строки
     * @property {string} tableTabKeyActive - текущий таб
     */
    props:{
        isActive: {
            type: Boolean,
            default: false
        },
        tableDataOptions: {
            type: Object,
            default: () => ({})
        },
        tableDataColumns: {
            type: Object,
            default: () => ({})
        },
        deep: {
            type: Number,
            default: 0
        },
        // tableDataRows: {
        //     type: Object,
        //     default: () => ({})
        // },
        tableDataRows: {
            type: Map,
            default: () => (new Map())
        },
        tableDataRowsActive: {
            type: Array,
            default: () => ([])
        },
        rowKey: {
            type: String,
            default: ''
        },
        rowKeyPreloader: {
            type: String,
            default: ''
        },
        tableSubdata: {
            type: Object,
            default: () => ({})
        },
        condition: {
            type: Object,
            default: () => ({})
        },
        tableTabKeyActive: {
            type: String,
            default: () => ''
        },
    },
    methods: {
        /**
         * событие клика по строке
         * @param {string} rowKey - ключ строки
         */
        onClickTableItem(rowKey) {
            let {next = ''} = this.tableDataOptions;
            let condition = {
                ...this.condition,
                [next]: rowKey
            };
            let element = next;
            this.onEmitClickTableItem(condition, element, rowKey);
        },
        /**
         * эмит события клика по строке таблицы
         * @param {object} condition - элементы иерархии дерева
         * @param {string} element - ключ элемента
         * @param {string} rowKey - ключ строки
         */
        onEmitClickTableItem(condition, element, rowKey) {
            this.$emit('onEmitClickTableItem', condition, element, rowKey);
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-multiline__td-number {
        text-align: right;
        position: relative;
        white-space: nowrap;
    }
    td.table-multiline__td-name {
        border-right: 3px solid #f5f7f9;
        width: 300px;
        white-space: nowrap;
    }
    td {
        padding: 16px 14px;
        border-bottom: 1px solid #f5f7f9;
    }
    .table_plus {
        cursor: pointer;
        border: 1px solid #f5f7f9;
        width: 16px;
        height: 16px;
        text-align: center;
        line-height: 14px;
        border-radius: 3px;
        font-size: 10px;
        margin-right: 10px;
        color: #b0b1b4;
        background: #fff;
        transition: all 250ms;
    }

    .table_plus:hover {
        background: #fe1060;
        color: #fff;
        border-color: #fe1060;
    }

    tbody tr:last-child td {
        border-bottom: 0;
    }

    tbody tr.tr__sub {
        background: #fbfbfb;
    }

    tbody tr.tr__sub.tr__sub-two {
        background: #fff;
    }

    tbody tr.tr__sub.tr__sub-three {
        background: #fff;
    }

    tbody tr.tr__sub td:first-child {
        padding-left: 36px;
    }

    tbody tr.tr__sub.tr__sub-two td:first-child {
        padding-left: 64px;
    }

    tbody tr.tr__sub.tr__sub-three td:first-child {
        padding-left: 93px;
    }

    tbody tr:hover {
        background: #f5f7f9 !important;
    }
</style>